import { precio } from '../lib/formato.js';
import { FlechaDerecha } from '../componentes/Iconos.jsx';

/**
 * Cómo quiere pagar.
 *
 * Aparece después del horario y sólo si el servicio ofrece pagar online. El
 * que no cobra online no ve este paso y la barra de progreso tiene un tramo
 * menos: un paso que nunca se va a usar hace que el avance parezca trabado.
 *
 * ─── Por qué botones y no un selector ──────────────────────────────────────
 *
 * Porque son dos o tres opciones con un número adentro, y el número es lo que
 * decide. Un <select> las esconde atrás de un toque y obliga a abrirlo para
 * comparar $4.000 contra $10.000, que es justo la comparación que la persona
 * vino a hacer acá. Son los mismos botones que los servicios y los horarios,
 * que es lo que viene tocando desde la primera pantalla.
 *
 * El orden tampoco es casual: primero lo más barato. Arriba pagar en el local
 * —cero— y abajo el total. Empezar por lo caro se lee como un empujón.
 */
export function PasoPago({ opciones, politica, elegido, onElegir }) {
  return (
    <div className="lista">
      {opciones.local && (
        <OpcionDePago
          elegida={elegido === 'sin_pago'}
          onElegir={() => onElegir('sin_pago')}
          titulo="Pago en el local"
          detalle="Reservás ahora y pagás cuando vas."
        />
      )}

      {opciones.senia_centavos > 0 && (
        <OpcionDePago
          elegida={elegido === 'senia'}
          onElegir={() => onElegir('senia')}
          titulo="Pagar seña"
          detalle="El resto lo pagás en el local."
          monto={opciones.senia_centavos}
        />
      )}

      {opciones.total_centavos > 0 && (
        <OpcionDePago
          elegida={elegido === 'total'}
          onElegir={() => onElegir('total')}
          titulo="Pagar total"
          detalle="Llegás con todo pago."
          monto={opciones.total_centavos}
        />
      )}

      {/* Lo que pasa si cancela, sólo cuando hay algo que perder. Al que paga
          en el local no le aplica, y mostrárselo igual lo asusta sin motivo. */}
      {politica && elegido && elegido !== 'sin_pago' && (
        <p className="nota-pago">{politica}</p>
      )}
    </div>
  );
}

function OpcionDePago({ elegida, onElegir, titulo, detalle, monto }) {
  return (
    <button type="button" className="opcion" aria-pressed={elegida} onClick={onElegir}>
      <span className="opcion-cuerpo">
        <span className="opcion-nombre">{titulo}</span>
        <span className="opcion-detalle">{detalle}</span>
      </span>
      {monto > 0 && <span className="opcion-precio">{precio(monto)}</span>}
      <FlechaDerecha className="opcion-flecha" />
    </button>
  );
}
